export const styleStatisticsSheet = (XLSX, ws) => {
  if (!ws["!ref"]) return;
  const range = XLSX.utils.decode_range(ws["!ref"]);
  ws["!cols"] = Array.from({ length: range.e.c + 1 }, (_, c) => {
    let width = 10;
    let hasDate = /(^|_)data(_|$)|date/i.test(String(ws[XLSX.utils.encode_cell({ r: 0, c })]?.v || ""));
    for (let r = 1; r <= range.e.r; r++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (cell) width = Math.max(width, XLSX.utils.format_cell(cell).length + 3);
      if (cell?.z === "dd/mm/yyyy") hasDate = true;
    }
    const header = ws[XLSX.utils.encode_cell({ r: 0, c })];
    if (header) header.s = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2563EB" } },
      alignment: { vertical: "center", wrapText: true },
    };
    return { wch: hasDate ? 16 : Math.min(45, Math.max(width, Math.min(24, String(header?.v || "").length + 3))) };
  });
  ws["!rows"] = [{ hpt: 45 }];
  for (let r = 1; r <= range.e.r; r++) {
    let lines = 1;
    for (let c = 0; c <= range.e.c; c++) {
      const cell = ws[XLSX.utils.encode_cell({ r, c })];
      if (!cell) continue;
      cell.s = { ...cell.s, alignment: { vertical: "center", wrapText: true } };
      lines = Math.max(lines, Math.ceil(XLSX.utils.format_cell(cell).length / (ws["!cols"][c].wch - 2)));
    }
    ws["!rows"][r] = { hpt: lines * 15 };
  }
};
